export default "/_next/static/images/ben-williamson-e1b4c0423a18980ee0fc8e7ecb7090bf.png";